import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class ConcreteFloor extends Floor {
	static key = "ConcreteFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): ConcreteFloor {
		const f = new ConcreteFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
